import { appConfig } from '../../config/appConfig';
import { logger } from '../../utils/logger';
import { scanTimedOut } from '../../state/appState';
import { setInstruction } from './InstructionOverlay';

// Scanning overlay — SCANNING state.
// 1. Shows "Scanning for sign…" after scanningOverlayDelayMs (500 ms).
// 2. If the anchor is not acquired within scanGuidanceTimeoutMs (60 s),
//    transitions to SCAN_GUIDANCE.
// Returns a cleanup function that cancels both timers and clears the text.
// Call cleanup whenever the state leaves SCANNING (success or guidance).

export function mountScanningOverlay(slot: HTMLElement): () => void {
  setInstruction(slot, null);

  // Timer 1 — show the scanning text after a brief delay.
  const textTimer = window.setTimeout(() => {
    logger.log('Scanning overlay appeared');
    setInstruction(slot, appConfig.copy.scanning);
  }, appConfig.scanningOverlayDelayMs);

  // Timer 2 — escalate to guidance if still scanning after 60 s.
  const guidanceTimer = window.setTimeout(() => {
    logger.log('Scan guidance timer fired, transitioning to SCAN_GUIDANCE');
    scanTimedOut();
  }, appConfig.scanGuidanceTimeoutMs);

  return () => {
    window.clearTimeout(textTimer);
    window.clearTimeout(guidanceTimer);
    setInstruction(slot, null);
  };
}
